import React from "react";
import { useNavigate } from "react-router-dom";
import image1 from "../../Assets/image1.jpg";
import image2 from "../../Assets/image2.jpeg";
import image3 from "../../Assets/image3.png";
import Headers from "../../Components/Headers";
import Footer from "../../Components/Footers";

const workshops = [
  {
    id: 1,
    title: "Threading Kefir",
    date: "15th December 2025",
    img: image1, // put these in public/images
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    priceLabel: "50 Euros",
  },
  {
    id: 2,
    title: "Cosmos and Albumen",
    date: "15th December 2025",
    img: image2,
    description:
      "It has survived not only five centuries but also the leap into electronic typesetting, remaining essentially unchanged.",
    priceLabel: "50 Euros",
  },
  {
    id: 3,
    title: "Activating Charcoal",
    date: "15th December 2025",
    img: image3,
    description:
      "It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
    priceLabel: "50 Euros",
  },
];

const WorkshopsPage = () => {
  const navigate = useNavigate();

  const handleCardClick = (id) => {
    const finalId = id ?? 3; // default 3
    navigate(`/descr/${finalId}`);
  };

  const handleStripeClick = async (workshopId, e) => {
    e.stopPropagation(); // don't trigger card click

    try {
      const res = await fetch("/api/create-checkout-session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ workshopId }),
      });

      const data = await res.json();
      if (data.url) {
        window.location.href = data.url; // redirect to Stripe
      } else {
        alert("Could not start payment");
        console.error(data);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Check console.");
    }
  };

  return (
    <>
      <Headers/>
    <div className="workshops-page">
      <h1 className="page-title">MoM šála - Workshops</h1>

      <div className="workshops-grid">
        {workshops.map((w) => (
          <div
            key={w.id}
            className="workshop-card"
            onClick={() => handleCardClick(w.id)}
          >
            <img src={w.img} alt={w.title} className="workshop-image" />

            <div className="workshop-content">
              <div className="workshop-d">Upcoming Workshop</div>
              <h2 className="workshop-title">{w.title}</h2>
              <p className="workshop-date">{w.date}</p>
              <p className="workshop-desc">{w.description}</p>
            </div>

            <div className="workshop-footer">
              <button
                className="price-button"
                onClick={(e) => handleStripeClick(w.id, e)}
              >
                {w.priceLabel}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default WorkshopsPage;
